import React, { useState, useEffect } from 'react';
import Hero from './EntryPage';
import { useLanguage } from '../i18n/LanguageContext';
import UnderConstruction from '../components/UnderConstruction';

export default function Events() {
  const { strings } = useLanguage();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const referrer = document.referrer;
   
  }, [strings]);

  return (
    <div className="main">
      <UnderConstruction />
    </div>
  );
}